export default __webpack_public_path__ + "static/betql-full-width-1-mobile-380c6645d23e0a022ec13ac557d3b66b.webp";